<template>
  <div class="tab">
    <div class="tab-scroll">
      <div class="tab-content">
        <div
          class="date"
          ref="date"
          v-for="(item, index) in seckillList"
          :key="index"
          :class="{ active: item.dateFormat === currentSeckill.dateFormat2 }"
          @click="$emit('getCurrentSeckill', item)"
        >
          {{ item.dateFormat }}
        </div>
      </div>
    </div>
    <div class="next" @click="clickNext">
      <van-icon name="arrow" size="1em"></van-icon>
    </div>
  </div>
</template>

<script>
import { Icon } from 'vant';
import BScroll from '@better-scroll/core';
import ObserveDOM from '@better-scroll/observe-dom';
BScroll.use(ObserveDOM);
export default {
  data() {
    return {
      scroll: null,
    };
  },
  props: {
    seckillList: {
      type: Array,
      default() {
        return [];
      },
    },
    currentSeckill: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  watch: {
    seckillList: {
      handler() {
        this.$nextTick(() => {
          this.initScroll();
        });
      },
      immediate: true,
    },
    currentSeckill(val) {
      const index = this.seckillList.findIndex((item) => item.dateFormat === val.dateFormat2);
      if (index > -1) {
        this.$nextTick(() => {
          const dateRef = this.$refs.date;
          setTimeout(() => {
            this.scroll.scrollToElement(dateRef[index], 1000, 0, 0);
          }, 200);
        });
      }
    },
  },
  methods: {
    initScroll() {
      if (this.scroll) {
        this.scroll.refresh();
        return;
      }
      this.scroll = new BScroll('.tab-scroll', {
        click: true,
        probeType: 3,
        scrollX: true,
        observeDOM: true,
      });
      const dateRef = this.$refs.date;
      if (dateRef.length > 0) {
        dateRef[0].parentElement.style.width =
          Math.ceil(dateRef[0].getBoundingClientRect().width * dateRef.length) + 'px';
      }
    },
    clickNext() {
      this.scroll.scrollTo(this.scroll.x - 50, 0);
    },
  },
  beforeDestroy() {
    this.scroll?.destroy();
  },
  components: {
    [Icon.name]: Icon,
  },
};
</script>

<style lang="scss" scoped>
.tab {
  background: #fff;
  position: fixed;
  top: 0;
  width: 100%;
  height: 66px;
  &-scroll {
    width: 100%;
    overflow: hidden;
    position: relative;
  }
  &-content {
    display: table;
    padding-right: 50px;
    .date {
      width: 222px;
      height: 66px;
      text-align: center;
      line-height: 66px;
      color: #895ae6;
      display: inline-block;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        height: 36px;
        top: 15px;
        width: 1px;
        right: 0;
        background: #c4c8ec;
      }
      &.active {
        background: linear-gradient(to bottom, #c193fe, #8a60f5);
        color: #fff;
      }
    }
  }
  .next {
    position: absolute;
    right: 0;
    top: 0;
    width: 50px;
    color: #956aea;
    height: 66px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(to bottom, #f4eeff, #d9c9ff);
  }
}
</style>
